import { call, put, takeLatest } from "redux-saga/effects";
import { customersActions } from "./customersSlice";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
import {
  CustomerPayload,
  CustomerSubmitForm,
  IdentityPayload,
} from "models/customer";
import customersApi from "api/customers";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* getCustomerList(action: PayloadAction<CustomerPayload>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.getCustomersList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(customersActions.getCustomerSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(customersActions.getCustomerFailed(errorData));
  }
}

function* addCustomer(action: PayloadAction<CustomerSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.addCustomer,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.addCustomerSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.addCustomerFailed(errorData));
  }
}

function* updateCustomer(action: PayloadAction<CustomerSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.updateCustomer,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.updateCustomerSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.updateCustomerFailed(errorData));
  }
}

function* addUpdateCustomer(action: PayloadAction<CustomerSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.addUpdateCustomer,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.addUpdateCustomerSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.addUpdateCustomerFailed(errorData));
  }
}

function* deleteCustomer(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.deleteCustomer,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.deleteCustomerSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.deleteCustomerFailed(errorData));
  }
}
function* getIdentityTypes(action: PayloadAction<IdentityPayload>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.getIdentityTypes,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.getIdentityTypesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.getIdentityTypesFailed(errorData));
  }
}

function* getprofileImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.getprofileImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.getprofileImageUrlFailed(errorData));
  }
}
function* getfrontIdImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.getfrontIdImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.getfrontIdImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.getfrontIdImageUrlFailed(errorData));
  }
}
function* getbackIdImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      customersApi.getbackIdImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(customersActions.getbackIdImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(customersActions.getbackIdImageUrlFailed(errorData));
  }
}

export default function* customersSaga() {
  yield takeLatest(customersActions.getCustomers.type, getCustomerList);
  yield takeLatest(customersActions.addCustomer.type, addCustomer);

  yield takeLatest(customersActions.updateCustomer.type, updateCustomer);
  yield takeLatest(customersActions.addUpdateCustomer.type, addUpdateCustomer);
  yield takeLatest(customersActions.deleteCustomer.type, deleteCustomer);
  yield takeLatest(
    customersActions.getprofileImageUrl.type,
    getprofileImageUrl
  );
  yield takeLatest(
    customersActions.getfrontIdImageUrl.type,
    getfrontIdImageUrl
  );
  yield takeLatest(customersActions.getbackIdImageUrl.type, getbackIdImageUrl);
  yield takeLatest(customersActions.getIdentityTypes.type, getIdentityTypes);
}
